import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  TextField,
  ThemeProvider,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import AuthLayout, { AuthLink } from './components/AuthLayout';
import { theme } from './theme';

export default function PasswordResetRequest(_props: { theme?: any }) {
  const { t } = useTranslation('auth');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const [successMsg, setSuccessMsg] = useState<string | null>(null);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setErrorMsg(null);
    setSuccessMsg(null);
    if (!email) {
      setErrorMsg(t('passwordReset.errorMissing'));
      return;
    }
    setLoading(true);
    fetch(`${process.env.REACT_APP_API}/auth/password/reset/request`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email.trim().toLowerCase() }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.statusCode && data.statusCode > 201)
          throw new Error(data.message || 'Request failed');
        setSuccessMsg(t('passwordReset.success', { email }));
        setLoading(false);
      })
      .catch((e) => {
        setErrorMsg(e.message || t('passwordReset.errorGeneric'));
        setLoading(false);
      });
  };

  return (
    <ThemeProvider theme={theme}>
      <AuthLayout
        title={t('passwordReset.title')}
        subtitle={t('passwordReset.subtitle')}
        footerLeft={
          <span style={{ color: '#8B95A8' }}>
            {t('passwordReset.remembered')} <AuthLink href="/login">{t('passwordReset.signIn')}</AuthLink>
          </span>
        }
      >
        {errorMsg && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {errorMsg}
          </Alert>
        )}
        {successMsg && (
          <Alert severity="success" sx={{ mb: 3 }}>
            {successMsg}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            fullWidth
            label={t('passwordReset.email')}
            type="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            disabled={loading}
            sx={{ py: 1.5, fontSize: '1rem' }}
          >
            {loading ? (
              <CircularProgress size={22} sx={{ color: '#0A0E1A' }} />
            ) : (
              t('passwordReset.sendResetLink')
            )}
          </Button>
        </Box>
      </AuthLayout>
    </ThemeProvider>
  );
}
